module.exports = __webpack_public_path__ + "static/media/ImgReceptionJp.1830c885.svg";